import { v4 as uuidv4 } from 'uuid';

export function Image(props) {
	return {
		componentName: 'Image',
		componentId: uuidv4(),
		props: Object.assign(
			{
				alt: '',
				title: '',
				src: '',
			},
			props,
		),
		childrenComponents: [],
	};
}
